module.exports = __webpack_public_path__ + "static/media/head-side.b4fe0062.svg";